module.exports = __webpack_public_path__ + "img/WS.adcc72ee.svg";